/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiUserActionUserFromJSON(json) {
    return ApiUserActionUserFromJSONTyped(json, false);
}
export function ApiUserActionUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audiences': !exists(json, 'audiences') ? undefined : json['audiences'],
        'browser': !exists(json, 'browser') ? undefined : json['browser'],
        'campaigns': !exists(json, 'campaigns') ? undefined : json['campaigns'],
        'channels': !exists(json, 'channels') ? undefined : json['channels'],
        'device': !exists(json, 'device') ? undefined : json['device'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstCampaign': !exists(json, 'firstCampaign') ? undefined : json['firstCampaign'],
        'firstChannel': !exists(json, 'firstChannel') ? undefined : json['firstChannel'],
        'firstSource': !exists(json, 'firstSource') ? undefined : json['firstSource'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'lastActivity': !exists(json, 'lastActivity') ? undefined : (new Date(json['lastActivity'])),
        'leadStatusRuleId': !exists(json, 'leadStatusRuleId') ? undefined : json['leadStatusRuleId'],
        'leadStatusRuleName': !exists(json, 'leadStatusRuleName') ? undefined : json['leadStatusRuleName'],
        'os': !exists(json, 'os') ? undefined : json['os'],
        'score': !exists(json, 'score') ? undefined : json['score'],
        'sources': !exists(json, 'sources') ? undefined : json['sources'],
        'totalRevenue': !exists(json, 'totalRevenue') ? undefined : json['totalRevenue'],
    };
}
export function ApiUserActionUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audiences': value.audiences,
        'browser': value.browser,
        'campaigns': value.campaigns,
        'channels': value.channels,
        'device': value.device,
        'email': value.email,
        'firstCampaign': value.firstCampaign,
        'firstChannel': value.firstChannel,
        'firstSource': value.firstSource,
        'id': value.id,
        'key': value.key,
        'lastActivity': value.lastActivity === undefined ? undefined : (value.lastActivity.toISOString()),
        'leadStatusRuleId': value.leadStatusRuleId,
        'leadStatusRuleName': value.leadStatusRuleName,
        'os': value.os,
        'score': value.score,
        'sources': value.sources,
        'totalRevenue': value.totalRevenue,
    };
}
